<div>
  <app-store-page *ngIf="!hasChild" [acceptTermVisible]="acceptTermVisible"></app-store-page>
  <app-store-child-showcase *ngIf="hasChild"> </app-store-child-showcase>
</div>